<template>
  <div
    class="ux-field"
    @focusin="focus"
    @focusout="blur"
    @mouseover.stop="hoverover"
    @mouseout.stop="hoverout"
    @click="clicked($event)"
    v-if="visible"
    :class="classes"
  >
    <template v-if="component">
      <component
        :is="component"
        @touched="touch"
        :field="actualField"
        v-model="fieldModel"
      />
    </template>
    <template v-else>
      <template v-if="widget == 'textfield'">
        <text-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'keyfield'">
        <key-field @touched="touch" :field="actualField" v-model="fieldModel" />
      </template>
      <template v-if="widget == 'internal-route'">
        <internal-route-select
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'internal-menu'">
        <internal-menu-select
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>

      <template v-if="widget == 'internal-field-creator'">
        <internal-field-creator
          v-model="definedField"
          :referenceType="actualField.referenceType"
        />
      </template>
      <template v-if="widget == 'html'">
        <custom-html
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'value'"> </template>
      <template v-if="widget == 'slider'">
        <slider-input
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'color'">
        <color-input
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'filter'">
        <filter-input
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'dateobject'">
        <date-object-input
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'signature'">
        <signature @touched="touch" :field="actualField" v-model="fieldModel" />
      </template>
      <template v-if="widget == 'checkbox'">
        <checkbox @touched="touch" :field="actualField" v-model="fieldModel" />
      </template>
      <template v-if="widget == 'switch'">
        <boolean-switch
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'upload'">
        <upload @touched="touch" :field="actualField" v-model="fieldModel" />
      </template>
      <template v-if="widget == 'group'">
        <template v-if="asObject">
          <field-group
            :trail="currentTrail"
            :paymentConfiguration="paymentConfiguration"
            :includeOfficeOnly="includeOfficeOnly"
            :submission="submission"
            :ignoreDefaults="shouldIgnoreDefaults"
            :sandbox="sandbox"
            @form:state="groupStateAltered"
            ref="group"
            @touched="touch"
            :field="actualField"
            :parentModel="parentModel"
            v-model="fieldModel"
          />
        </template>
        <template v-else>
          <field-group
            :trail="trail"
            :paymentConfiguration="paymentConfiguration"
            :includeOfficeOnly="includeOfficeOnly"
            :submission="submission"
            :ignoreDefaults="shouldIgnoreDefaults"
            :sandbox="sandbox"
            @form:state="groupStateAltered"
            ref="group"
            @touched="touch"
            :field="actualField"
            :parentModel="parentModel"
            v-model="sourceModel"
          />
        </template>
      </template>
      <template v-if="widget == 'form'">
        <field-group
          :trail="currentTrail"
          :paymentConfiguration="paymentConfiguration"
          :includeOfficeOnly="includeOfficeOnly"
          :submission="submission"
          :ignoreDefaults="shouldIgnoreDefaults"
          :sandbox="sandbox"
          @form:state="groupStateAltered"
          ref="group"
          @touched="touch"
          :field="actualField"
          :parentModel="parentModel"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'field-select'">
        <field-select
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'select'">
        <native-select
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'button'">
        <button-select
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'currency'">
        <currency-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>

      <template v-if="widget == 'form-relationship'">
        <form-relationship-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'datefield'">
        <date-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'timefield'">
        <time-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'daterange'">
        <date-range
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'content-select'">
        <content-select
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'content-search'">
        <content-search
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'type-select'">
        <type-select
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'scope-select'">
        <scope-select
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'richtext'">
        <rich-text-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'textarea'">
        <text-area @touched="touch" :field="actualField" v-model="fieldModel" />
      </template>
      <template v-if="widget == 'timezone'">
        <timezone-select
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'country'">
        <country-select
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'phone'">
        <phone-number-input
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'value'"> </template>
      <template v-if="widget == 'object'">
        <object-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'model'">
        <model-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'payment'">
        <payment-field
          :sandbox="sandbox"
          :configuration="paymentConfiguration"
          @form:state="groupStateAltered"
          :field="actualField"
          @touched="touch"
          :parentModel="parentModel"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'options'">
        <options-manager
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <flex-column style="min-height: 300px" v-if="widget == 'code'">
        <code-editor-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </flex-column>
      <template v-if="widget == 'location'">
        <location-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
      <template v-if="widget == 'expression'">
        <expression-field
          @touched="touch"
          :field="actualField"
          v-model="fieldModel"
        />
      </template>
    </template>
    <div v-if="error && validateResults.message" class="ux-field-message">
      {{ validateResults.message }}
    </div>
  </div>
</template>
<script>
//Inputs
import PhoneNumberInput from "./inputs/phone-number-input.vue";
import TimezoneSelect from "./inputs/timezone.vue";
import CountrySelect from "./inputs/country.vue";
import ContentSelect from "./inputs/content-select.vue";
import ContentSearchField from "./inputs/content-search-field.vue";
import TypeSelect from "./inputs/type-select.vue";
import ScopeSelect from "./inputs/scope-select.vue";
import CurrencyField from "./inputs/currency.vue";
import TextField from "./inputs/textfield.vue";
import KeyField from "./inputs/keyfield.vue";
import TextArea from "./inputs/textarea.vue";
import DateField from "./inputs/datefield.vue";
import TimeField from "./inputs/timefield.vue";
import DateRange from "./inputs/daterange.vue";
import Checkbox from "./inputs/checkbox.vue";
import CustomHTML from "./inputs/html.vue";
import DateObjectInput from "./inputs/dateobject-field.vue";
import FilterInput from "./inputs/filter.vue";
import FieldSelect from "./inputs/field-select.vue";
import SliderInput from "./inputs/slider.vue";
import ColorInput from "./inputs/color.vue";
import Switch from "./inputs/switch.vue";
import Upload from "./inputs/upload/upload.vue";
import FieldGroup from "./inputs/group.vue";
import NativeSelect from "./inputs/select.vue";
import ButtonSelect from "./inputs/button-select.vue";
import ObjectField from "./inputs/object-field.vue";
import ObjectModelField from "./inputs/model-field.vue";
import OptionsManager from "./inputs/options-manager.vue";
import CodeEditorField from "./inputs/code-editor-field.vue";
import LocationField from "./inputs/location-field.vue";
import ExpressionField from "./inputs/expression-field.vue";
import RichTextField from "./inputs/richtext-field.vue";
import PaymentField from "./inputs/payment.vue";
import Signature from "./inputs/signature-field.vue";

////////////////

//Internal Selectors
import InternalRouteSelect from "./internal/InternalRouteSelect.vue";
import InternalMenuSelect from "./internal/InternalMenuSelect.vue";
import InternalFieldCreator from "./internal/InternalFieldCreator.vue";

////////////////

import Expressions from "./expressions";
import getDefaultValue from "./getDefaultValue";
import parseBoolean from "./parseBoolean";

////////////////////////////////////////

import safeJsonStringify from "safe-json-stringify";
import { ref } from "vue";

////////////////////////////////////////

function hasExpression(key) {
  return function () {
    var self = this;
    if (!self.expressions) {
      return;
    }

    let expression = self.expressions[key];
    if (expression) {
      return true;
    }
  };
}

////////////////////////////////////////

function computedExpression(key) {
  return function () {
    var self = this;
    if (!self.expressions) {
      return;
    }

    let expression = self.expressions[key];
    if (!expression) {
      return;
    }

    let context = self.expressionsContext;

    let result = Expressions.evaluateExpression(expression, context);

    return result;
  };
}

export default {
  emits: [
    "field:mount",
    "field:unmount",
    "field:focus",
    "field:blur",
    "field:invalid",
    "field:valid",
    "field:error",
    "field:touched",
    "field:dirty",
    "update:modelValue",
  ],
  components: {
    InternalRouteSelect,
    InternalMenuSelect,
    InternalFieldCreator,
    ButtonSelect,
    NativeSelect,
    DateField,
    TimeField,
    DateRange,
    TextField,
    KeyField,
    CurrencyField,
    TextArea,
    Checkbox,
    FilterInput,
    FieldSelect,
    DateObjectInput,
    SliderInput,
    ColorInput,
    CustomHtml: CustomHTML,
    BooleanSwitch: Switch,
    FieldGroup,
    ContentSelect,
    ContentSearch: ContentSearchField,
    TypeSelect,
    ScopeSelect,
    FieldSelect,
    TimezoneSelect,
    CountrySelect,
    PhoneNumberInput,
    Upload,
    Signature,
    ObjectField,
    ModelField: ObjectModelField,
    OptionsManager,
    CodeEditorField,
    LocationField,
    ExpressionField,
    RichTextField,
    PaymentField,
  },
  props: {
    trail: {
      type: Array,
      default() {
        return [];
      },
    },
    submission: {
      type: Boolean,
      default: false,
    },
    ignoreDefaults: {
      type: Boolean,
      default: false,
    },
    sandbox: {
      type: Boolean,
      default: false,
    },
    paymentConfiguration: {
      type: Object,
    },
    field: {
      type: Object,
      required: true,
    },
    parentModel: {
      type: Object,
    },
    modelValue: {
      type: Object,
      required: true,
    },
    includeOfficeOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      definedField: this.field,
      watching: true,
      defaultValue: null,
      model: this.modelValue,
      touched: false,
      focussed: false,
      validateResults: { valid: true },
      mounted: false,
      subFormState: {},
      isDirty: false,
      isDirtyBeforeInput: false,
      appeared: false,
    };
  },
  inject: {
    parentFormElement: {
      default() {
        return;
      },
    },
    directParentModel: {
      default() {
        return;
      },
    },
    directFormElement: {
      default() {
        return;
      },
    },
    additionalContext: {
      default() {
        return;
      },
    },
    fieldIsHovered: {
      default() {
        return;
      },
    },
    fieldIsSelected: {
      default() {
        return;
      },
    },
    selectField: {
      default() {
        return;
      },
    },
    mouseOverField: {
      default() {
        return;
      },
    },
    mouseOutField: {
      default() {
        return;
      },
    },
  },
  provide() {
    return {
      fieldPath: this.fieldPath,
      directParentModel: this.model,
    };
  },
  created() {
    this.checkDirtyState(true);
  },
  mounted() {
    const self = this;
    self.mounted = true;

    if (self.directFormElement && self.directFormElement.childFormElements) {
      self.directFormElement.childFormElements.push(self);
    }
    if (self.parentFormElement && self.parentFormElement.childFormElements) {
      self.parentFormElement.childFormElements.push(self);
    }
  },
  beforeUnmount() {
    const self = this;
    self.mounted = false;

    if (self.directFormElement) {
      var index = self.directFormElement.childFormElements.indexOf(self);
      self.directFormElement.childFormElements.splice(index, 1);
    }

    if (self.parentFormElement) {
      var index = self.parentFormElement.childFormElements.indexOf(self);
      self.parentFormElement.childFormElements.splice(index, 1);
    }
  },
  methods: {
    clicked($event) {
      const self = this;
      if (self.selectField && self.sandbox) {
        self.selectField(self.field);
        $event.stopImmediatePropagation();
        $event.stopPropagation();
      }
    },
    hoverover() {
      const self = this;
      if (self.sandbox && self.mouseOverField) {
        self.mouseOverField(self.field);
      }
    },
    hoverout() {
      const self = this;
      if (self.sandbox && self.mouseOutField) {
        self.mouseOutField(self.field);
      }
    },
    fieldDefaultValue() {
      var expressionForceValue =
        this.expressions && this.expressions.value
          ? this.getExpressionValue
          : undefined;
      if (expressionForceValue) {
        return expressionForceValue;
      }

      // If there is no expression
      var expressionDefaultValue =
        this.expressions && this.expressions.defaultValue
          ? this.getExpressionDefaultValue
          : undefined;
      var normalDefaultValue = getDefaultValue(this.actualField);

      var defaultValue = this.cleanInput(
        expressionDefaultValue || normalDefaultValue,
      );

      if (this.field?.assumeDefault) {
        // Set timezone selectors to the current timezone of the user
        if (!defaultValue && this.widget === "timezone") {
          defaultValue = this.$sdk.geo.getDefaultTimezone();
          console.log("Set the default timezone:", defaultValue);
        }

        // Set country selectors to the current country of the user
        if (!defaultValue && this.widget === "country") {
          const defaultCountry = this.$sdk.geo.getDefaultCountry();
          defaultValue = defaultCountry?.name;
          console.log("Set the default country:", defaultCountry, defaultValue);
        }

        if (!defaultValue && this.field?.type === "date") {
          defaultValue = new Date();
        }
      }

      return defaultValue;
    },
    checkDirtyState(isInitial) {
      const self = this;

      //What is the value for this field right now?
      var existingData = self.fieldModel;
      var hasExistingData =
        self.ignoreDefaults ||
        existingData ||
        existingData === false ||
        existingData === 0;

      var proposedDefaultValue = self.fieldDefaultValue();

      ///////////////////////////////////////////

      var existingString = JSON.stringify(self.cleanOutput(existingData));
      var proposedString = JSON.stringify(
        self.cleanOutput(proposedDefaultValue),
      );

      //We already have data

      let dirtyOnInputCheck;
      if (isInitial) {
        dirtyOnInputCheck = hasExistingData;
      } else {
        dirtyOnInputCheck = hasExistingData && existingString != proposedString;
      }

      if (dirtyOnInputCheck) {
        self.isDirty = true;
        self.isDirtyBeforeInput = true;
        //May as well put it in anyway so it can clean itself if need be
        self.fieldModel = existingData;
      } else {
        //The field is untouched
        self.isDirty = false;
        self.isDirtyBeforeInput = false;

        //Use the default
        self.fieldModel = proposedDefaultValue;
      }

      // Validate when we're first mounted
      self.validateResults = self.$sdk.content.validateField(
        self.fieldModel,
        self.actualField,
      );
    },
    groupStateAltered(details) {
      this.subFormState = details;
    },
    focus() {
      this.focussed = true;
    },
    blur() {
      this.focussed = false;
      if (this.expressions && this.expressions.value) {
        //Reset the value after we blur out
        this.fieldModel = this.getExpressionValue;
      }
    },
    touch() {
      this.touched = true;
    },
    untouch() {
      this.touched = false;
    },
    reset() {
      this.untouch();
      this.watching = false;

      var defaultValue = this.fieldDefaultValue();

      if (Array.isArray(defaultValue)) {
        defaultValue = [];
      }

      this.model[this.key] = defaultValue;

      this.$nextTick(function () {
        this.watching = true;
      });
    },

    cleanInput(val) {
      return this.fieldCleanInput(val);
    },
    cleanOutput(val) {
      return this.fieldCleanOutput(val);
    },
    fieldCleanInput(val) {
      var self = this;
      var transformFunction = self.expressions?.transform;

      if (transformFunction && typeof transformFunction.set === "function") {
        val = transformFunction.set(val);
      }

      if (self.field.type === "key") {
        val = String(self.$sdk.utils.machineName(val || "") || "").trim();
      }

      return val;
    },
    fieldCleanOutput(val) {
      var self = this;
      var transformFunction = self.expressions?.transform;

      if (transformFunction && typeof transformFunction.get === "function") {
        val = transformFunction.get(val);
      }

      return val;
    },
  },
  watch: {
    isSelected(now) {
      if (now) {
        if (this.$el?.scrollIntoView) {
          this.$el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }
    },
    mounted(val) {
      if (val) {
        this.$emit("field:mount", this);
      } else {
        this.$emit("field:unmount", this);
      }

      // if(this.expressions && this.expressions.show) {
      //     console.log(this.field.title, this.expressions, this.expressionsContext)

      // }
    },
    visible(now, before) {
      const self = this;
      //Remove and clear all data
      if (!now) {
        self.touched = false;
        if (self.expressions && self.expressions.value) {
          self.fieldModel = self.getExpressionValue;
        } else {
          if (self.ignoreDefaults) {
            // Don't remove the data that has been input
          } else {
            self.fieldModel = undefined;
          }
        }
      } else {
        self.untouch();
      }
    },
    focussed(val) {
      if (val) {
        this.$emit("field:focus", this);
      } else {
        this.$emit("field:blur", this);
      }
    },
    invalid(val) {
      this.$emit("field:invalid", this);
    },
    valid(val) {
      this.$emit("field:valid", this);
    },
    error(val) {
      this.$emit("field:error", this);
    },
    touched(val) {
      this.$emit("field:touched", this);
    },
    dirty(val) {
      this.$emit("field:dirty", this);
    },
    changeString(v) {
      this.validateResults = this.$sdk.content.validateField(
        this.fieldModel,
        this.actualField,
      );
    },
    modelValue(val, old) {
      if (this.watching) {
        this.model = val;
        this.touched = false;
        this.checkDirtyState();
      }
    },
    async getExpressionHide(nowHidden, thenHidden) {
      if (!nowHidden && thenHidden) {
        this.appeared = true;
        await this.$nextTick();
        this.appeared = false;
      }
    },
    getExpressionDefaultValue(result) {
      //If this already had data, or has been touched and now has data
      if (this.isDirtyBeforeInput || (this.touched && this.dirty)) {
        //Don't update it
      } else {
        this.fieldModel = result;
      }
    },
    getExpressionValue(result) {
      this.fieldModel = result;
    },
  },
  computed: {
    isSelected() {
      return this.fieldIsSelected && this.fieldIsSelected(this.field);
    },
    isHovered() {
      return this.fieldIsHovered && this.fieldIsHovered(this.field);
    },
    shouldIgnoreDefaults() {
      return this.ignoreDefaults && !this.appeared;
    },
    fieldPath() {
      return this.currentTrail.join(".");
    },
    currentTrail() {
      var trail = this.trail.slice();
      trail.push(this.field.key);
      return trail;
    },
    title() {
      return this.field.title;
    },
    minimum() {
      return parseInt(this.actualField.minimum);
    },
    maximum() {
      return parseInt(this.actualField.maximum);
    },
    actualField() {
      var field = this.field;
      var actual = field;

      if (this.getExpressionRequired) {
        actual = Object.assign({}, actual, { minimum: 1 });
      }

      if (this.getExpressionTitle) {
        actual = Object.assign({}, actual, { title: this.getExpressionTitle });
      }

      if (this.getExpressionDescription) {
        actual = Object.assign({}, actual, {
          description: this.getExpressionDescription,
        });
      }

      if (this.getExpressionPlaceholder) {
        actual = Object.assign({}, actual, {
          placeholder: this.getExpressionPlaceholder,
        });
      }

      if (this.getExpressionReferenceType) {
        actual = Object.assign({}, actual, {
          referenceType: this.getExpressionReferenceType,
        });
      }

      if (this.getExpressionAllDay) {
        actual = Object.assign({}, actual, {
          allDay: this.getExpressionAllDay,
        });
      }

      if (this.getExpressionVisualHide) {
        actual = Object.assign({}, actual, {
          visualHide: this.getExpressionVisualHide,
        });
      }

      if (this.getExpressionWidgetType) {
        actual = Object.assign({}, actual, {
          widget: this.getExpressionWidgetType,
        });
      }

      if (this.getExpressionDataType) {
        actual = Object.assign({}, actual, {
          type: this.getExpressionDataType,
        });
      }

      if (this.getExpressionOptions) {
        actual = Object.assign({}, actual, {
          options: this.getExpressionOptions,
        });
      }

      if (this.getExpressionSyntax) {
        actual = Object.assign({}, actual, {
          syntax: this.getExpressionSyntax,
        });
      }

      if (this.getExpressionFields) {
        actual = Object.assign({}, actual, {
          fields: this.getExpressionFields,
        });
      }

      if (this.getExpressionMinValue) {
        actual = Object.assign({}, actual, {
          minValue: this.getExpressionMinValue,
        });
      }

      if (this.getExpressionMinDate) {
        actual = Object.assign({}, actual, {
          minDate: this.getExpressionMinDate,
        });
      }

      if (this.getExpressionMaxDate) {
        actual = Object.assign({}, actual, {
          maxDate: this.getExpressionMaxDate,
        });
      }

      if (this.getExpressionStepValue) {
        actual = Object.assign({}, actual, {
          stepValue: this.getExpressionStepValue,
        });
      }

      if (this.getExpressionMaxValue) {
        actual = Object.assign({}, actual, {
          maxValue: this.getExpressionMaxValue,
        });
      }

      if (this.getExpressionCurrency) {
        actual = Object.assign({}, actual, {
          currency: this.getExpressionCurrency,
        });
      }

      return actual;
    },
    changeString() {
      const fieldModel = this.fieldModel;
      const stringified = safeJsonStringify(fieldModel);

      return `${stringified}-${this.actualField.minimum}-${this.actualField.referenceType}`;
    },
    valid() {
      return !this.invalid;
    },
    error() {
      return !this.focussed && this.touched && this.invalid;
    },
    invalid() {
      // Layout-only groups and void fields should never be considered invalid
      const isLayoutGroup =
        this.field?.type === "group" && !this.field?.asObject;
      const isVoidField = this.field?.type === "void";

      if (isLayoutGroup || isVoidField) {
        return false;
      }

      //Check the subform
      var invalidSubForm = this.subFormState && this.subFormState.invalid;
      if (invalidSubForm) {
        return { invalidSubForm: this.subFormState, mounted: this.mounted };
      }

      //Check if our validator says this field is valid
      var isInvalid = !this.validateResults.valid;

      if (this.hidden) {
        return false;
      }

      return isInvalid;
    },
    dirty() {
      return this.isDirty;
    },
    getExpressionHide() {
      if (!this.expressions) {
        return;
      }

      let showExpression = this.expressions.show;
      let hideExpression = this.expressions.hide;
      let context = this.expressionsContext;

      let result;
      if (showExpression) {
        result = !!!Expressions.evaluateExpression(showExpression, context);
      } else if (hideExpression) {
        result = Expressions.evaluateExpression(hideExpression, context);
      }

      return result;
    },
    getExpressionTitle: computedExpression("title"),
    getExpressionDescription: computedExpression("description"),
    getExpressionPlaceholder: computedExpression("placeholder"),
    getExpressionRequired: computedExpression("required"),
    getExpressionDefaultValue: computedExpression("defaultValue"),
    getExpressionValue: computedExpression("value"),
    getExpressionReferenceType: computedExpression("referenceType"),
    getExpressionAllDay: computedExpression("allDay"),
    getExpressionWidgetType: computedExpression("widget"),
    getExpressionDataType: computedExpression("type"),
    getExpressionOptions: computedExpression("options"),
    getExpressionSyntax: computedExpression("syntax"),
    getExpressionFields: computedExpression("fields"),
    getExpressionCurrency: computedExpression("currency"),
    getExpressionMinValue: computedExpression("minValue"),
    getExpressionStepValue: computedExpression("stepValue"),
    getExpressionMaxValue: computedExpression("maxValue"),
    getExpressionMinDate: computedExpression("minDate"),
    getExpressionMaxDate: computedExpression("maxDate"),
    getExpressionVisualHide: computedExpression("visualHide"),
    // hasExpressionDefaultValue: hasExpression('defaultValue'), // Not sure what this is for
    expressions() {
      return this.field?.expressions;
    },
    expressionUser() {
      if (this.user) {
        return this.user;
      }
      const currentUser = this.$sdk.auth.getCurrentUser();
      return currentUser;
    },
    expressionsContext() {
      const self = this;

      const { firstName, lastName, email } = self.expressionUser || {};

      const user = {
        firstName,
        lastName,
        email,
      };

      var additionalContext =
        self.additionalContext?.value || self.additionalContext || {};

      const parent = self.directParentModel;

      const context = {
        this: self.model,
        self: self.model,
        model: self.model,
        data: self.parentModel || self.model,
        parent,
        additional: {
          ...additionalContext,
        },
        user,
      };

      return context;
    },
    officeOnly() {
      return this.submission && this.field.officeOnly;
    },
    hidden() {
      if (this.officeOnly && !this.includeOfficeOnly) {
        return true;
      }

      if (this.actualField?.readOnly) {
        return true;
      }
      return this.getExpressionHide;
    },
    visible() {
      const vis = this.field && this.mounted && !this.hidden;
      return vis;
    },
    type() {
      return this.actualField?.type || "string";
    },
    key() {
      return this.actualField?.key;
    },
    isGroup() {
      return this.type === "group";
    },
    asObject() {
      return (
        this.widget === "form" || (this.isGroup && this.actualField.asObject)
      );
    },
    visualHide() {
      return this.actualField?.visualHide;
    },
    layoutGroup() {
      return this.isGroup && !this.actualField.asObject;
    },
    fieldModel: {
      get() {
        return this.cleanOutput(this.model[this.key]);
      },
      set(value) {
        var cleaned = this.cleanInput(value);
        const existing = this.model[this.key];

        if (existing != cleaned) {
          this.model[this.key] = cleaned;
          this.isDirty = true;
          this.$emit("update:modelValue", this.model);
        }
      },
    },
    sourceModel: {
      get() {
        return this.model;
      },
      set(value) {
        this.model = value;
        this.$emit("update:modelValue", this.model);
      },
    },

    classes() {
      var array = [];
      array.push(`ux-field-${this.type}`);
      array.push(`ux-field-widget-${this.widget}`);

      if (this.widget === "form" && this.minimum === 1 && this.maximum === 1) {
        array.push("ux-layout-only");
      }

      if (this.isHovered) {
        array.push("hover");
      }

      if (this.isSelected) {
        array.push("selected");
      }

      if (this.layoutGroup) {
        array.push("ux-layout-only");
      }

      if (this.touched) {
        array.push("ux-field-touched");
      }

      if (this.dirty) {
        array.push("ux-field-dirty");
      }

      if (this.valid) {
        array.push("ux-field-valid");
      }

      if (this.invalid) {
        array.push("ux-field-invalid");
      }

      if (this.error) {
        array.push("ux-field-error");
      }

      if (this.visualHide) {
        array.push("ux-field-hide");
      }

      return array;
    },
    component() {
      return this.field.component;
    },
    widget() {
      //We're a group
      if (this.type == "group") {
        return this.type;
      }

      //Get the widget
      var widget = this.actualField.widget;

      ///////////////////////////////

      ///////////////////////////////

      switch (widget) {
        case "form":
          widget = this.submission ? "form" : "content-select";
          break;
        case "upload":
          widget =
            this.submission && !this.includeOfficeOnly
              ? "upload"
              : "content-select";
          break;
        case "content-search":
          return widget;
        case "location":
        case "payment":
        case "internal-menu":
        case "internal-route":
        case "internal-field-creator":
        case "content-select":
        case "select":
        case "checkbox":
        case "daterange":
        case "richtext":
        case "textarea":
        case "switch":
        case "email":
        case "url":
        case "currency":
        case "timezone":
        case "country":
        case "code":
        case "expression":
        case "options":
        case "type-select":
        case "scope-select":
        case "field-select":
        case "html":
        case "dateobject":
        case "filter":
        case "value":
        case "slider":
        case "color":
        case "model":
        case "signature":
          break;
        case "button":
        case "buttons":
        case "buttonselect":
          return "button";
        case "date":
        case "datefield":
        case "datepicker":
          return "datefield";
        case "timefield":
        case "timepicker":
          return "timefield";
        case "password":
          return "textfield";
        case "key":
        case "keyfield":
          return "keyfield";
        case "phone":
        case "phonenumber":
          return "phone";
        default:
          switch (this.type) {
            case "date":
              widget = "datefield";
              break;
            case "reference":
              widget = "content-select";
              break;
            case "boolean":
              widget = "checkbox";
              break;
            default:
            case "string":
              widget = "textfield";
              break;
            case "object":
              widget = "object";
              break;
          }
          break;
      }

      return widget;
    },
  },
};
</script>
<style lang="scss" scoped>
.ux-field {
  margin-bottom: 1em;

  &.ux-layout-only {
    margin-bottom: 0;
  }

  .ux-field-message {
    border: red;
    background: rgba(red, 0.1);
    color: red;
    font-size: 0.7em;
    padding: 0.3em 0.5em;
    border-radius: 0 1em 1em;
    margin: 0.3em 0;
    display: inline-block;
  }

  // &.ux-field-error {
  // .ux-field-message {
  // visibility: visible;
  // }
  // }
}

:deep(.ux-field-title) {
  margin-top: 0.5em;
  display: block;
  margin-bottom: 0.2em;
  font-size: 0.9em;
  font-weight: 500;
}

.ux-field.ux-field-hide {
  display: none !important;
  margin: 0 !important;
}

:deep(.ux-field-description) {
  font-size: clamp(12px, 0.8em, 16px);
  opacity: 0.5;
  margin-bottom: 0.5em;
}

.ux-field.ux-field-error > :deep(.ux-field-title) {
  color: red;
}

:deep(.ux-form-flex .ux-field-description) {
  // min-height: 2.6em;
}
</style>
